/* eslint-disable import/no-extraneous-dependencies */
import { notification } from 'antd'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { createHttpLink } from 'apollo-link-http'
import { REACT_APP_API_URL } from './REACT_APP_URL'


const API_END_POINT = `${REACT_APP_API_URL}/graphql`

console.log(API_END_POINT, 'check endpoint')

const httpLink = createHttpLink({
  uri: API_END_POINT,
})

const errorLink = onError(({ graphQLErrors, networkError, response, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      notification.error({
        message,
        duration: 10,
        // description: message,
      }),
    )
  }
})

const httperrorLink = errorLink.concat(httpLink)

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  let token = ''
  if (!(localStorage.getItem('token') === null) && localStorage.getItem('token')) {
    token = JSON.parse(localStorage.getItem('token'))
  }
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      database: 'india',
      Authorization: token ? `JWT ${token}` : '',
    },
  }
})

const authhttperrorLink = authLink.concat(httperrorLink)

export default new ApolloClient({
  link: authhttperrorLink,
  cache: new InMemoryCache(),
})
